export const FolderAction = {
  Delete: 'Delete',
  Leave: 'Leave',
  Restore: 'Restore',
  Share: 'Share',
}
